import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { initAppState } from 'client/redux/store';
import { setInited, setUserStateInited } from 'client/redux/modules/flags';
import { handleInitError, setupPromoApp } from 'client/hooks/useInitPromo/useInitPromo';
import getPromoInfoData from 'client/hooks/useInitPromo/getPromoInfoData';

function useInitMontage(promoUUID) {
    const dispatch = useDispatch();
    const [data, setData] = useState('');

    useEffect(() => {
        async function initMontage() {
            try {
                const promoInfo = await getPromoInfoData(promoUUID, ['mgmRelation', 'pointPool']);
                const isUgcWithContestModule = Boolean(promoInfo.relatedTwinsPromo);
                const promoInfoState = isUgcWithContestModule
                    ? {
                          ...promoInfo.relatedTwinsPromo,
                          sponsor: promoInfo.sponsor,
                          partner: promoInfo.partner
                      }
                    : promoInfo;
                promoInfoState.promo.promoIdOfUgcLink = promoInfo.promo.id;
                setData(promoInfoState);
                await setupPromoApp(promoInfoState);
                dispatch(initAppState(promoInfoState));
                dispatch(setInited());
                dispatch(setUserStateInited());
            } catch (error) {
                handleInitError({ error, dispatch });
            }
        }
        initMontage();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return data;
}

export default useInitMontage;
